import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getEventById, getEventInfosByEventId, getTicketTypesByEventId, getTicketTypeInfosByTicketTypeId, getTicketTypeNumberOfAvailableTickets } from "ticketino-api-client";
import axios from "axios";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Loading from "./components/Loading";

import imgIconProgressCompleted from "../images/progress-bar/ball-completed.svg";
import imgIconProgress from "../images/progress-bar/ball-progress.svg";

import imgIconInfo from "../images/icons/info.svg";
import imgIconAdd from "../images/icons/add.svg";
import imgIconRemove from "../images/icons/remove.svg";


const Home = () => {
    const [orderId, setOrderId] = useState();

    const [eventId, setEventId] = useState();
    const [posId, setPosId] = useState();
    const [event, setEvent] = useState({});

    const [ticketTypes, setTicketTypes] = useState([]);
    const [selectedTicketQuantities, setSelectedTicketQuantities] = useState({});

    const [moreInfo, setMoreInfo] = useState({});

    const [disabled, setDisabled] = useState(true);
    const [loading, setLoading] = useState(true);
    const [loaded, setLoaded] = useState(false);

    const [promotioncode, setPromotioncode] = useState("");
    const [promotioncodeAdded, setPromotioncodeAdded] = useState("");
    const [promotionError, setPromotionError] = useState("");

    const [unlockedTicketTypes, setUnlockedTicketTypes] = useState([]);
    const [isTicketTypesUnlocked, setIsTicketTypesUnlocked] = useState(false);

    const [eventIdWorkshopsSaturday, setEventIdWorkshopsSaturday] = useState([]);

    const [ticketTypeIdSkipWorkshops, setTicketTypeIdSkipWorkshops] = useState();

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching params
    let { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    useEffect(() => {
        loadToken();

        // clear the addedPromocodes in the session
        let array = [];
        sessionStorage.setItem("AddedPromotions", JSON.stringify(array));
    }, []); //only on first page load

    useEffect(() => {
        requestResources();

        // so it wont get called on first load
        if (loaded) {
            startOrder(posId, eventId);
        }
    }, [language]); //everytime language is changed

    useEffect(() => {
        if (orderId) {
            loadEvent(eventId, orderId)
        }
    }, [orderId]); //gets called when an order is started

    const loadToken = async () => {
        await axios.get("form/token").then((res) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
            api.defaults.headers.common['Authorization'] = "Bearer " + res.data;

            sessionStorage.setItem("token", res.data);

            requestFormSettings();
        });
    };

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            // setting the posID and eventID
            setPosId(res.data.posId);
            setEventId(res.data.eventId);
            setEventIdWorkshopsSaturday(res.data.eventIdWorkshopsSaturday);
            setTicketTypeIdSkipWorkshops(res.data.ticketTypeIdSkipWorkshops);

            startOrder(res.data.posId, res.data.eventId);
        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const startOrder = async (posId, eventId) => {
        let order = {
            affiliateShopId: null,
            currency: "CHF",
            tenantId: 1,
            languageId: languageId,
            pointOfSaleId: posId,
            abbreviation: "",
            paymentType: 10,
        };

        await axios
            .post(`${baseUrl}/ShopBasket/Order`, order)
            .then((res) => {
                sessionStorage.setItem("orderId", res.data.id);
                setOrderId(res.data.id);
                setLoaded(true);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadEvent = async (eventId, orderId) => {
        try {
            setLoading(true);

            // Event
            const event = await getEventById(eventId);
            const infos = await getEventInfosByEventId(eventId);

            // sorting it according to the language
            const eventInfo = infos.eventInfos.find(info => info.languageId == languageId);

            // setting the eventInfo object in the info attribute of event
            const updatedEventInfo = { ...event, info: eventInfo };

            // TicketType
            const ticketTypes = await getTicketTypesByEventId(eventId);

            const updatedTicketTypes = await Promise.all(
                ticketTypes.map(async (ticketType) => {
                    const info = await getTicketTypeInfosByTicketTypeId(ticketType.id);

                    // sorting it according to the language
                    const ticketTypeInfo = info.find(info => info.languageId == languageId) ?? info[0];

                    const ticketTypeAvailability = await getTicketTypeNumberOfAvailableTickets(ticketType.id, orderId);

                    // setting the ticketTypeInfo and ticketTypeAvailability object as attributes in ticketType (info and availability)
                    return { ...ticketType, info: ticketTypeInfo, availability: ticketTypeAvailability }
                })
            )

            // setting the values in the end
            setEvent(updatedEventInfo);
            setTicketTypes(updatedTicketTypes);
            setLoading(false);

        } catch (error) {
            console.error(error);
        }
    }

    const applyPromotionCodeToOrder = async (orderId, code) => {
        try {
            const response = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${code}`);
            return response.data;
        } catch (error) {
            console.error(error.response.data);
            setPromotionError(resources?.PromotionError);
        }
    }

    const deletePromotionCodeFromOrder = async (orderId, code) => {
        try {
            const response = await axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${code}`);
            return response.data;
        } catch (error) {
            console.error(error.response.data);
            setPromotionError(resources?.PromotionError);
        }
    }

    const getTicketTypeAvailability = async (ticketTypeId, orderId, promotionCode) => {
        try {
            const response = await axios.get(`${baseUrl}/TicketType/${ticketTypeId}/Availability?orderId=${orderId}&promotionCode=${promotionCode}`);
            return response.data;
        } catch (error) {
            console.error(error.response.data);
            setPromotionError(resources?.PromotionError);
        }
    }

    const addPromotionToOrder = async () => {
        setPromotionError("");
        setLoading(true);

        const updatedUnlockedTicketTypes = await applyPromotionCodeToOrder(orderId, promotioncode);
        let updatedTicketTypes = [];

        updatedTicketTypes = await Promise.all(ticketTypes.map(async (ticketType) => {
            if (updatedUnlockedTicketTypes?.unlockedTicketTypes?.includes(ticketType.id)) {
                const unlockedTicketTypeAvailability = await getTicketTypeAvailability(ticketType.id, orderId, promotioncode);
                ticketType.availability = unlockedTicketTypeAvailability;
            }
            return ticketType;
        }))

        sessionStorage.setItem("addedPromotion", promotioncode);
        setPromotioncodeAdded(promotioncode);

        //Workaround - Redirect to Saturday Workshops if promocode is "WORKSHOP", this promocode allow the person to proceed without initialy adding a ticket to the basket
        if (promotioncode.toLocaleLowerCase() === "workshop") {
            sessionStorage.setItem("countSaturdayTickets", 10);
            sessionStorage.setItem("countSundayTickets", 10);
            navigate(`/${language}/workshops-saturday`);
        } 

        setTicketTypes(updatedTicketTypes)
        setUnlockedTicketTypes(updatedUnlockedTicketTypes?.unlockedTicketTypes ?? []);
        setIsTicketTypesUnlocked(true);
        setLoading(false);
    }

    const removePromotionFromOrder = async () => {
        setPromotionError("");
        setLoading(true);

        await deletePromotionCodeFromOrder(orderId, promotioncode);
        await loadEvent(eventId, orderId);

        setUnlockedTicketTypes([]);
        setIsTicketTypesUnlocked(false);
        setLoading(false);
    }

    const addTicketToBasket = async () => {
        let addTicketTypes = Object.entries(selectedTicketQuantities)
            .filter(([_, quantity]) => quantity > 0)
            .map(([ticketTypeId, quantity]) => {
                const ticket = {
                    ticketTypeId: parseInt(ticketTypeId),
                    quantity,
                };

                if (unlockedTicketTypes.includes(ticket.ticketTypeId)) {
                    ticket.promotionCode = promotioncodeAdded;
                }

                return ticket;
            });

        let saturdayCount = 0;
        let sundayCount = 0;

        const saturdayKeywords = ["samstag", "saturday", "wochenend", "weekend", "vip ticket"];
        const sundayKeywords = ["sonntag", "sunday", "wochenend", "weekend", "vip ticket"];
        const excludeKeywords = ["abendeventticket", "evening", "früher zugang", "early access"];

        addTicketTypes.forEach(({ ticketTypeId, quantity }) => {
            const ticketType = ticketTypes.find(tt => tt.id === ticketTypeId);
            const name = ticketType?.info?.name?.toLowerCase() ?? "";

            // Skip if the name contains any of the excluded keywords
            if (excludeKeywords.some(exclude => name.includes(exclude))) {
                return;
            }

            if (saturdayKeywords.some(k => name.includes(k))) {
                saturdayCount += quantity;
            }
            if (sundayKeywords.some(k => name.includes(k))) {
                sundayCount += quantity;
            }
        });

        sessionStorage.setItem("countSaturdayTickets", saturdayCount);
        sessionStorage.setItem("countSundayTickets", sundayCount);

        await axios
            .post(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                ticketsToAdd: addTicketTypes,
            })
            .then(() => {
                // gtm - addToCart
                //window.dataLayer = window.dataLayer || [];
                //window.dataLayer.push({
                //    event: 'addToCart',
                //});

                // ticket type id to skip workshops
                const allTicketTypeIdsAreHaveNoWorkshops = addTicketTypes.every(ticket => ticket.ticketTypeId === ticketTypeIdSkipWorkshops);

                if (allTicketTypeIdsAreHaveNoWorkshops) {
                    navigate(`/${language}/address`);
                } else {
                    if (saturdayCount > 0) {
                        navigate(`/${language}/workshops-saturday`);
                    } else if (sundayCount > 0) {
                        navigate(`/${language}/workshops-sunday`);
                    } else {
                        navigate(`/${language}/address`);
                    }
                }
            })
            .catch((error) => {
                console.error(error.response?.data);
            });
    };

    const onSubmit = async () => {
        await addTicketToBasket();
    };

    const incrementTicket = (id, max) => {
        setSelectedTicketQuantities((prev) => {
            const current = prev[id] || 0;

            // If this is an unlocked ticket type
            if (unlockedTicketTypes.includes(id)) {
                const otherUnlockedSelected = unlockedTicketTypes.some(
                    unlockedId => unlockedId !== id && (prev[unlockedId] || 0) > 0
                );

                // If another unlocked ticket is already selected, do nothing
                // only one unlocked ticket type can be added to the basket
                if (otherUnlockedSelected) {
                    return prev;
                }
            }

            const newQuantities = {
                ...prev,
                [id]: Math.min(current + 1, max),
            };

            const hasAtLeastOne = Object.values(newQuantities).some(q => q > 0);
            setDisabled(!hasAtLeastOne);

            return newQuantities;
        });
    };

    const decrementTicket = (id) => {
        setSelectedTicketQuantities((prev) => {
            const current = prev[id] || 0;
            const newQuantities = {
                ...prev,
                [id]: Math.max(current - 1, 0),
            };

            const hasAtLeastOne = Object.values(newQuantities).some(q => q > 0);
            setDisabled(!hasAtLeastOne);

            return newQuantities;
        });
    };

    const mapTicketTypes = () => {
        let ticketTypesSorted = [];

        if (ticketTypes && ticketTypes.length > 0) {
            ticketTypesSorted = [...ticketTypes].sort((a, b) => a.sortOrder - b.sortOrder);
        }

        return (
            ticketTypes &&
            ticketTypes.length > 0 &&
            (() => {
                const visibleTickets = ticketTypesSorted.filter(tt => tt.availability?.status === 0 || tt.availability?.status === 1);

                return (
                    <>
                        {visibleTickets.map((tt, index) => (
                            <div key={tt.id}>
                                <hr className="ticket-separator" /> {/* top lines */}

                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center flex-nowrap">
                                        <div className="d-flex align-items-center gap-2">
                                            {tt.availability?.availableTickets === 0 ? (
                                                <span className="text-soldout">{resources?.SoldOut}</span>
                                            ) : (
                                                <>
                                                    <button
                                                        type="button"
                                                        className="btn-counter"
                                                        onClick={() => decrementTicket(tt.id)}
                                                        disabled={(selectedTicketQuantities[tt.id] || 0) <= 0}
                                                    >
                                                        <img src={imgIconRemove} alt="Decrease" width="16" height="16" />
                                                    </button>

                                                    <span className="ticket-quantity">{selectedTicketQuantities[tt.id] || 0}</span>

                                                    <button
                                                        type="button"
                                                        className="btn-counter"
                                                        onClick={() => incrementTicket(tt.id, tt.availability?.availableTickets)}
                                                        disabled={(selectedTicketQuantities[tt.id] || 0) >= tt.availability?.availableTickets}
                                                    >
                                                        <img src={imgIconAdd} alt="Increase" width="16" height="16" />
                                                    </button>
                                                </>
                                            )}
                                        </div>

                                        <label className={`ms-4 ticket-name-label ${unlockedTicketTypes.includes(tt.id) ? 'fw-bold text-pink' : ''}`}>
                                            {tt.info?.name}
                                        </label>
                                    </div>

                                    <label className="text-nowrap">
                                        {tt.currency} {tt.price.toFixed(2)}
                                    </label>
                                </div>

                                {index === visibleTickets.length - 1 && (
                                    <hr className="ticket-separator" /> // bottom line only after last visible
                                )}
                            </div>
                        ))}
                    </>
                );
            })()
        );
    };

    return (
        <>
            <Header language={language} pagePath="home" />
            <div className="page-container">

                {/* progress bar */}
                <div className="progressbar-wrapper">
                    <div className="progressbar-lines">
                        <div className="line" />
                        <div className="line" />
                        <div className="line" />
                    </div>

                    <div className="progressbar-steps">
                        <div className="progress-step active">
                            <div className="circle">
                                <img src={imgIconProgressCompleted} alt="Step 1" />
                            </div>
                            <div className="label">{resources?.ProgressTickets}</div>
                        </div>

                        <div className="progress-step">
                            <div className="circle">
                                <img src={imgIconProgress} alt="Step 2" />
                            </div>
                            <div className="label">
                                {resources?.ProgressWorkshops}<br />{resources?.ProgressOptional}
                            </div>
                        </div>

                        <div className="progress-step">
                            <div className="circle">
                                <img src={imgIconProgress} alt="Step 3" />
                            </div>
                            <div className="label">{resources?.ProgressAdditionalInformation}</div>
                        </div>

                        <div className="progress-step">
                            <div className="circle">
                                <img src={imgIconProgress} alt="Step 4" />
                            </div>
                            <div className="label">{resources?.ProgressCheckout}</div>
                        </div>
                    </div>
                </div>

                <div className="container wrapper">
                    <div className="row fw-bold text-pink mt-5">
                        <div className="d-flex align-items-start">
                            <img src={imgIconInfo} alt="Increase" width="18" height="18" className="me-2" />
                            <span dangerouslySetInnerHTML={{ __html: resources?.YouNeedAValidTicketHome }}></span>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-md-12">
                            <span className="text-subtitle">{resources?.HomeChooseCategory}</span>
                        </div>
                    </div>

                    <div className="row tickets-box mt-2">
                        <div className="col-md-12">
                            {!loading ? mapTicketTypes() : <Loading bgColor="transparent" color="#00726f" resources={resources} />}
                        </div>
                    </div>

                    {/* promocodes */}
                    <div className="mt-5">
                        <p className="text-subtitle mb-2">{resources?.PromotionCode}</p>
                        <p dangerouslySetInnerHTML={{ __html: resources?.PromotionDescription }}></p>
                        <div className="row">
                            <div className="col-md-4 col-8 mb-3">
                                <input className="form-control" placeholder="Code" disabled={ unlockedTicketTypes.length > 0 }  value={promotioncode} onChange={(e) => setPromotioncode(e.target.value)} />
                            </div>
                            <div className="col-md-4">
                                <button className="btn btn-custom" disabled={promotioncode < 3 || unlockedTicketTypes.length > 0} onClick={addPromotionToOrder}>{resources?.PromotionRedeem}</button>
                                {/*<button className="btn button-custom d-block" onClick={removePromotionFromOrder}>{resources?.PromotionRemove}</button>*/}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                {promotionError !== "" &&
                                    <span className="error">{promotionError}</span>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-md-12 text-end">
                            <button className="btn btn-custom" disabled={disabled} onClick={() => onSubmit()}>{resources?.Next}</button>
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-12 text-center">
                            <p className="mt-4">
                                <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none', fontSize: '13px' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <Footer language={language} />
        </>
    )
}

export default Home